import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ApiDriverAssetResponse } from '../models/driver.models';

@Injectable({
  providedIn: 'root'
})
export class DriverAssetService {
  url = `${environment.locationApi.url}/vehicle_driver_association`;

  constructor(private http: HttpClient) {}

  getDriverDetails(
    accountId: string,
    assetId: string,
    startTimestamp: string,
    endTimestamp: string
  ): Observable<ApiDriverAssetResponse> {
    const params = { accountId, vin: assetId, startTime: startTimestamp, endTime: endTimestamp };
    const httpParams = new HttpParams({ fromObject: params as any });
    return this.http.get(this.url, { params: httpParams }) as Observable<ApiDriverAssetResponse>;
  }
}
